import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_PROMPTS_QUERY_KEY } from './useGetPrompts';

import PromptsService, {
  FilterPromptsDto,
  Prompt,
} from '@/services/PromptsService';

export function useSetPromptAsMain(filters: FilterPromptsDto) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: string) => {
      const result = await PromptsService.setAsMain(id);
      return result;
    },

    onMutate: async (id: string) => {
      await queryClient.cancelQueries({
        queryKey: GET_PROMPTS_QUERY_KEY(filters),
      });

      const previousPrompts = queryClient.getQueryData(
        GET_PROMPTS_QUERY_KEY(filters),
      );

      queryClient.setQueryData(GET_PROMPTS_QUERY_KEY(filters), (old: any) => {
        if (!old?.pages) return old;

        return {
          ...old,
          pages: old.pages.map((page: any) => {
            return {
              ...page,
              items: page.items.map((prompt: Prompt) => ({
                ...prompt,
                main: prompt.id === id,
              })),
            };
          }),
        };
      });

      return { previousPrompts };
    },

    onError: (_, __, context) => {
      if (context?.previousPrompts) {
        queryClient.setQueryData(
          GET_PROMPTS_QUERY_KEY(filters),
          context.previousPrompts,
        );
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: GET_PROMPTS_QUERY_KEY(filters),
      });
    },
  });

  return {
    setPromptAsMain: mutateAsync,
    isSettingAsMain: isPending,
  };
}
